exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-toggle::after {\n\tdisplay:none;\n}\n.pro-img img {\n    width: 200px;\n    height: 200px;\n    display: block;\n\tmargin: 0 auto;\n    -o-object-fit: cover;\n       object-fit: cover;\n    border-radius: 100%;\n}\n.profile-img-bg {\n    margin-bottom: 20px;\n}\n.pro-img-btn {\n    margin-top: 20px;\n}\n.pro-img {\n    text-align: center;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/user/profile/profile.component.css
// module id = ../../../../../src/app/user/profile/profile.component.css
// module chunks = main